export default __webpack_public_path__ + "static/media/ledger-icon.e1f751f9.svg";